import React, { useEffect, useState } from "react";
import { RouterProvider } from "react-router";
import { appRouter } from "src/router";
import { SpinnerOverlayOnly } from "common/components/Spinner";
import { setupServiceWorker } from "common/services/serviceWorker.service";

export const App: React.FC = () => {
  // State to manage the readiness of the service worker
  const [isServiceWorkerReady, setServiceWorkerReady] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== "development" && "serviceWorker" in navigator) {
      registerServiceWorker();
    } else {
      console.error("Service worker not supported.");

      setServiceWorkerReady(true);
    }
  }, []);

  const registerServiceWorker = async () => {
    setupServiceWorker(navigator);
    setServiceWorkerReady(true);
  };

  // Render a loading screen based on the service worker readiness
  if (!isServiceWorkerReady) {
    return <SpinnerOverlayOnly />;
  }

  return <RouterProvider router={appRouter} />;
};
